export const SnackbarPosition = {
  TOP: "top",
  BOTTOM: "bottom",
};

